export default __webpack_public_path__ + "static/alpaca_finance_institutions_defi_crypto-1534b74b991e87e6158afa29ac8806fb.jpeg";